"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalNav = void 0;
var _react = _interopRequireDefault(require("react"));
var _Breadcrumbs = _interopRequireDefault(require("@mui/material/Breadcrumbs"));
var _Breadcrumb = require("../components/Breadcrumb");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ModalNav = exports.ModalNav = function ModalNav(_ref) {
  var steps = _ref.steps,
    stepName = _ref.stepName,
    goToStep = _ref.goToStep;
  var crumbs = [];
  var has_link = true;
  Object.values(steps).forEach(function (step) {
    var step_name = step.props.name;
    var props = {
      key: step_name
    };
    if (has_link) {
      props["onClick"] = function () {
        return goToStep(step_name);
      };
    }
    if (step_name === stepName) {
      props["active"] = true;
      has_link = false;
    } else {
      props["color"] = "inherit";
    }
    crumbs.push( /*#__PURE__*/_react.default.createElement(_Breadcrumb.Breadcrumb, props, (0, _utils.titleCase)(step_name)));
  });
  return /*#__PURE__*/_react.default.createElement(_Breadcrumbs.default, {
    "aria-label": "breadcrumb",
    component: "span",
    separator: ">"
  }, crumbs);
};